import Vue from 'vue'
import store from './store'
import 'sproutmoney-checkout-vuejs/lib/assets/styles/main.scss'
import { expressCheckouts } from 'sproutmoney-checkout-vuejs/lib/index'

Vue.config.productionTip = false

const userObj = {
  first_name: '',
  last_name: '',
  email: ''
}

const user = window.user || userObj

// express-checkout component
// available globally
Vue.use(expressCheckouts, {
  store,
  user,
  apiUrl: process.env.VUE_APP_API_URL,
  blogName: 'Money Makers',
  accountUrl: '/account'
})

new Vue({
  el: '#vuejs-express-checkout',
  store
})
